export default class Menu {
  constructor(node) {
    this.node = node

    this.burgerMenu = this.node.querySelector('.burger-menu')
    this.headerMenu = this.node.querySelector('.header-menu')
    this.menuLinks = Array.from(
      this.headerMenu.querySelectorAll('.menu-link:not(.menu-link--anchor)')
    )
    this.menuAnchorLinks = Array.from(
      this.headerMenu.querySelectorAll('.menu-link--anchor')
    )

    this.clickAction = this.clickAction.bind(this)

    this.init()
  }

  init() {
    this.addListeners()
  }

  addListeners() {
    this.burgerMenu.addEventListener('click', this.clickAction)

    this.menuLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        setTimeout(() => {
          this.headerMenu.classList.remove('open')
          this.burgerMenu.classList.remove('open')
        }, 650)

        document.querySelector('html').classList.remove('h-noscroll')
      })
    })

    this.menuAnchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        this.headerMenu.classList.remove('open')
        this.burgerMenu.classList.remove('open')
        document.querySelector('html').classList.remove('h-noscroll')
      })
    })
  }

  clickAction(e) {
    e.preventDefault()

    this.headerMenu.classList.toggle('open')
    this.burgerMenu.classList.toggle('open')
    document.querySelector('html').classList.toggle('h-noscroll')
  }

  static init() {
    Menu.item = new Menu(document.querySelector('.header'))
  }
}
